import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { ListPayload } from '@product/shared/models/ListPayload';
import { Product } from '@product/shared/models/product';
import { productColumns } from '@product/shared/product-base-logic';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { tap } from 'rxjs';
import { HardCopy } from 'src/global-variables';

@Component({
  selector: 'app-related-products',
  templateUrl: './related-products.component.html',
  styleUrls: ['./related-products.component.less'],
})
export class RelatedProductsComponent extends BaseComponent implements OnInit {
  @Input() categoryId:number;
  @Input() typeLabel:string='';
  @ViewChild('productsDrawerTemplate', { static: false })
  productsDrawerTemplate: TemplateRef<any>;
  @ViewChild('recordsDrawerFooter') recordsDrawerFooter: TemplateRef<any>;
  tempProductsDrawerRef: NzDrawerRef<any, any>;
  _products: Product[] = [];
  baseProducts: Product[] = [];
 @Output() refrshRelatedProduct=new EventEmitter();
 @Input() set products(products: Product[]) {
    this.tempSelectedProducts = new Set<any>(
      products.map((product) => {
        return {
          id: product.id!,
          sku: product.sku!,
          name: product.name!,
          type: product.type!,
        };
      })
    );
    this.baseProducts = HardCopy(products);
    this._products = products;
    this.isLoading = false;
  }
  get products() {
    return this._products;
  }
  @Output() selectedProductsChanged = new EventEmitter();
  modalRecords: any[] = [];
  productsPayload: ListPayload = {
    SearchValue: '',
    Filters: {},
    IsAscend: false,
    SortBy: 'Id',
    PageIndex: 0,
    PageSize: 10,
    Attributes: [],
  };
  totalProductsCount = 0;
  listColumns = productColumns;
  tempSelectedProducts = new Set<{
    id: number;
    sku: string;
    name: string;
    type: string;
  }>();
  tableParams = {
    index: 1,
    size: 10,
  };
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {}
  checked = false;
  indeterminate = false;
  setOfCheckedIds = new Set<number>();
  selectedProductIds: number[] = [];
  listOfSelection = [
    {
      text: 'Select All',
      onSelect: () => {
          this.checked = true;
          this.products.forEach(product=>{
            this.setOfCheckedIds.add(product.id!);
            
          });
          this.products.forEach(pro=>{
            this.selectedProductIds.push(pro.id!)
          })
      //  this.getRelatedProducts();
      }
    },
    // {
    //   text: 'Select All In Page',
    //   onSelect: () => {
    //       this.products.forEach(product=>{
    //         this.setOfCheckedIds.add(product.id!);
            
    //       });
    //       debugger
    //       this.products.forEach(pro=>{
    //         this.ids.push(pro.id)
    //       })
    //     this.indeterminate = true;
        
    //   }
    // },
    {
      text: 'Deselect',
      onSelect: () => {
        this.setOfCheckedIds.clear();
        this.indeterminate = false;
        this.checked = false;

      }
    }
  ];

  removeProduct(id: number) {
    this.products = [...this.products.filter((x) => x.id !== id)];
    this.selectedProductsChanged.emit(this.products.map((x) => x.id));
  }
  getModalProducts() {
    this.commonService
      .getProducts(this.productsPayload)
      .pipe(
        tap((response) => {
          this.modalRecords = response.records;
          this.totalProductsCount = response.recordsCount;
          this.isLoading = false;
        })
      )
      .subscribe();
  }
  showRecordsModal() {
    this.getModalProducts(); 
    this.tempProductsDrawerRef = this.drawerService.create({
      nzTitle: 'Choose records to add',
      nzContent: this.productsDrawerTemplate,
      nzWidth: '90%',
      nzFooter: this.recordsDrawerFooter,
    });
  }
  onProductSelectionChange(selectedRecords: Set<Product>) {
    // Adding existed product ids to the set of selected records
    // in order to get unique values
    this.products.forEach((id) => {
      selectedRecords.add(id);
    });
    this.tempSelectedProducts = new Set<any>(selectedRecords);
 
    // this.selectedProductsChanged.emit(Array.from(selectedRecords));
  }
  handleFiltersChanges(filter: any) {
    if (filter == null) return;
    // deleting the filter if the value was null or empty
    const additionalInfo = JSON.parse(filter.filter?.AdditionalInfo ?? '{}');
    if (
      (['', null, undefined, 'null'].includes(filter.filter?.Value?.trim()) &&
        additionalInfo.needValue == null) ||
      (additionalInfo.needValue != null && additionalInfo.needValue === true)
    ) {
      delete this.productsPayload.Filters[filter.code];
    }
    const keys = Object.keys(this.productsPayload.Filters);

    if (keys.includes(filter.code)) {
      this.productsPayload.Filters[filter.code] = filter.filter;
    } else if (
      !['', null, undefined, 'null'].includes(filter.filter?.Value) ||
      additionalInfo.needValue === false
    ) {
      this.productsPayload.Filters = {
        ...this.productsPayload.Filters,
        [filter.code]: filter.filter,
      };
    }
    this.getModalProducts();
  }

  selectRows() {
    this.selectedProductsChanged.emit(Array.from(this.tempSelectedProducts));
    this.tempProductsDrawerRef.close();
  }
  cancelSelection() {
    this.tempSelectedProducts.clear();
    this.tempProductsDrawerRef.close();
  }
  onSearch(text: string) {
    if (text == null || text === '') {
      this._products = [...this.baseProducts];
      return;
    }
    this._products = [
      ...this.products.filter(
        (x) => x.name!.includes(text) || x.sku!.includes(text)
      ),
    ];
  }

  
  selection(id: any): void {
  
  if (this.setOfCheckedIds.has(id)) {
    this.setOfCheckedIds.delete(id);
  } else {
    this.setOfCheckedIds.add(id);
  }
}

bullkDelete(){
  if(this.categoryId>0 && this.selectedProductIds.length>0){
  this.categoryService.bulkDeleteCategoryProducts(this.categoryId,this.selectedProductIds).subscribe({
      next:(data)=>{
      
        this.refrshRelatedProduct.emit();
        this.setOfCheckedIds.clear();
        this.indeterminate = false;
        this.checked = false;
        this.message.success('Deleted successfully');
      },
      error:(error)=>{
        this.message.error('errors')
        
      }
    })
  }else{
    this.message.error('An error occurred. Please try again.');

  }
  
  }


getRelatedProducts(){
 this.categoryService.selectAllCategoryProducts(this.categoryId).subscribe({
  next:(data)=>{
    this.selectedProductIds=data;
     this.setOfCheckedIds = new Set<number>(this.selectedProductIds);
  }
 })
}

}
